module.exports = __webpack_public_path__ + "static/media/Sharon A. Szafranski@2x.3df8897a.jpg";